/**
 * defa.collections.Invoices
 * A collection of Invoice models.
 * @version 1.2.0
 */
import { defa } from 'defa-object';
import Invoice  from 'scripts/defa/invoices/model-invoice';

const apiHost = defa.vars.apiHost;

const api = {
	usages          : apiHost + '/usages',
	customerInvoices: apiHost + '/customers/%s/invoices',
};

const Invoices = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model: Invoice,
	url  : function () {
		return api.customerInvoices.replace( '%s', this.options.customerId );
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * @constructor
	 */
	initialize: function ( options ) {
		this.options = options || {};
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Fetch by customer id.
	 * @void
	 */
	fetchCustomerInvoices: function ( options ) {
		
		if ( options.customerId ) {
			this.options.customerId = options.customerId;
		}
		
		this.fetch( {
			url: api.customerInvoices.replace( '%s', this.options.customerId ),
		} );
		
	},
	
	
} );

export default Invoices;